export enum MemberRetirementTypeIdEnum {
  Normal = 1,
  BoardDirected = 2,
  Phased = 3
}
